import React from "react";
import glamorous from "glamorous";
import { FormControl, FormGroup, InputGroup } from "react-bootstrap";
import Select from "react-select";

import { Countries, StatesCA, StatesMX, StatesUS } from "./LocationEditData";
import Colors from "../../styles/colors";
import { LadChicletCSS as Chiclet } from "../../components/chiclets";
import { getLadName } from "../../components/lads";
import GeofenceEditForm from "../geofence-edit/GeofenceEditForm";

export const InputCell = ({ label, value, placeholder, onChange }) => {
  return (
    <FormCell label={label}>
      <FormControl
        style={{
          backgroundColor: "white",
          height: "3em",
          boxShadow: "none",
          borderRadius: "5px",
          borderWidth: 2
        }}
        type="text"
        value={value || ""}
        placeholder={placeholder}
        onChange={evt => onChange(evt.target.value)}
      />
    </FormCell>
  );
};

export const NumberInputCell = ({ label, value, placeholder, onChange }) => {
  return (
    <FormCell label={label}>
      <FormControl
        style={{
          backgroundColor: "white",
          height: "3em",
          boxShadow: "none",
          borderRadius: "5px",
          borderWidth: 2
        }}
        type="number"
        value={value || ""}
        placeholder={placeholder}
        onChange={evt => onChange(evt.target.value)}
      />
    </FormCell>
  );
};

const SelectCell = ({ label, options, value, onChange }) => {
  return (
    <FormCell label={label}>
      <Select
        style={{
          backgroundColor: "white",
          height: "3em",
          minWidth: "100%",
          boxShadow: "none",
          borderRadius: "5px",
          borderWidth: 2
        }}
        menuContainerStyle={{ zIndex: 999 }}
        options={options}
        simpleValue
        clearable={false}
        value={value}
        onChange={value => onChange(value)}
      />
    </FormCell>
  );
};

const LADSelectCell = ({ label, options, value, onChange, lads }) => {
  const renderOption = option => {
    return (
      <glamorous.Div
        css={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start"
        }}
      >
        <glamorous.Div css={{ minWidth: 20, marginRight: "1em" }}>
          <Chiclet
            height={25}
            width={25}
            lad={lads.find(l => l.id === option.value)}
          />
        </glamorous.Div>
        {option.label}
      </glamorous.Div>
    );
  };

  const renderValue = option => {
    return (
      <glamorous.Div
        css={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start"
        }}
      >
        <glamorous.Div css={{ minWidth: 20, marginRight: "0.5em" }}>
          <Chiclet
            height={25}
            width={25}
            lad={lads.find(l => l.id === option.value)}
          />
        </glamorous.Div>
        {option.label.substring(0, option.label.indexOf("("))}
      </glamorous.Div>
    );
  };

  return (
    <FormCell label={label}>
      <Select
        optionRenderer={renderOption}
        valueRenderer={renderValue}
        style={{
          backgroundColor: "white",
          height: "3em",
          minWidth: "100%",
          boxShadow: "none",
          borderRadius: "5px",
          borderWidth: 2
        }}
        menuContainerStyle={{ zIndex: 999 }}
        options={options}
        simpleValue
        clearable={false}
        value={value}
        onChange={value => onChange(value)}
      />
    </FormCell>
  );
};

const FormCell = props => {
  const { label } = props;

  return (
    <glamorous.Div
      css={{
        display: "flex",
        flexDirection: "column",
        paddingRight: "0.5em",
        paddingLeft: "0.5em",
        flex: 1
      }}
    >
      <span style={{ color: Colors.background.DARK_BLUE, marginBottom: "5px" }}>
        {label}
      </span>
      <FormGroup>
        <InputGroup style={{ width: "100%" }}>{props.children}</InputGroup>
      </FormGroup>
    </glamorous.Div>
  );
};

const FormRow = glamorous.div(
  {
    display: "flex",
    flexFlow: "row wrap",
    marginLeft: "0.5em",
    marginRight: "0.5em",
    justifyContent: "flex-start",
    alignItems: "flex-end"
  },
  ({ divider }) => ({
    borderBottom: divider ? `1px solid ${"#ddd"}` : "none",
    marginBottom: divider ? `1em` : "none"
  })
);

const LocationEditForm = ({ data, lads, updateField, mergeData, H }) => {
  const ladOptions = lads.map(l => {
    const ladName = getLadName(l);
    const lobName = l.lob_name;
    return { value: l.id, label: `${ladName} (${lobName})` };
  });

  return (
    <glamorous.Div
      css={{ display: "flex", flex: 1, flexDirection: "column", padding: "1em", backgroundColor: "white" }}
    >
      <FormRow>
        <InputCell
          label="Location Name"
          value={data.name}
          onChange={value => updateField("name", value)}
        />
      </FormRow>
      <FormRow divider={true}>
        <LADSelectCell
          label="Location Type"
          options={ladOptions}
          value={data.lad ? Number(data.lad.id) : null}
          onChange={value => updateField("lad", { ...data.lad, id: value })}
          lads={lads}
        />
         <InputCell
          label="Location Code"
          value={data.code}
          onChange={value => updateField("code", value)}
        />
        <SelectCell
          label="Country"
          options={Countries}
          value={data.country}
          onChange={value => updateField("country", value)}
        />
      </FormRow>
      <FormRow>
        <InputCell
          label="Address 1"
          value={data.address}
          onChange={value => updateField("address", value)}
        />
        <InputCell
          label="Address 2"
          value={data.address2}
          onChange={value => updateField("address2", value)}
        />
      </FormRow>
      <FormRow divider={true}>
        <InputCell
          label="City"
          value={data.city}
          onChange={value => updateField("city", value)}
        />
        <SelectCell
          label={data.country === "CA" ? "Province" : "State"}
          options={data.country === "CA" ? StatesCA : (data.country === "MX" ? StatesMX : StatesUS)}
          value={data.state}
          onChange={value => updateField("state", value)}
        />
        <InputCell
          label="Postal Code"
          value={data.postal_code}
          onChange={value => updateField("postal_code", value)}
        />
      </FormRow>
      {data.geofence && (
        <FormRow>
          <GeofenceEditForm
            data={data}
            mergeData={mergeData}
            H={H}
          />
        </FormRow>
      )}
    </glamorous.Div>
  );
};

export default LocationEditForm;



// WEBPACK FOOTER //
// ./src/modules/location-edit/LocationEditForm.js